import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { ColumnsType } from 'antd/es/table';
import TcInput from 'components/UI/form/input/TcInput';
import TcInputNationalID from 'components/UI/form/input/TcInputNationalID';
import TcFormItem from 'components/UI/form/TcFormItem';
import TcPopconfirm from 'components/UI/Popconfirm/TcPopconfirm';
import TcDeletIcon from 'components/UI/TableIcons/TcDeletIcon';
import TcEditIcon from 'components/UI/TableIcons/TcEditIcon';
import routes from 'global/Constants/routes';
import { IActors } from 'global/Models/globalModels';

export interface client extends IActors {
  fullName: string;
  telephonNumber: string;
  mobile: string;
  nationalId: string;
  fidaCode: string;
  id: number;
  isDefaultSender: boolean;
}

const title = 'مشتریان من';
const englishTitle = 'client';
const filterItems = (
  <>
    <TcFormItem label='نام و نام خانوادگی' name='fullName'>
      <TcInput placeholder='نام و نام خانوادگی' />
    </TcFormItem>
    <TcFormItem label='شماره موبایل' name='mobile'>
      <TcInput placeholder='شماره موبایل' maxLength={11} />
    </TcFormItem>
    <TcInputNationalID required={false} />
    <TcFormItem label='تلفن ثابت' name='telephonNumber'>
      <TcInput placeholder='تلفن ثابت' maxLength={12} />
    </TcFormItem>
  </>
);
const inputs = (
  <>
    <TcFormItem label='نام و نام خانوادگی' name='fullName' rules={[{ required: true, message: 'نام و نام خانوادگی وارد نشده' }]}>
      <TcInput placeholder='نام و نام خانوادگی' />
    </TcFormItem>
    <TcFormItem label='شماره موبایل' name='mobile' rules={[{ required: true, message: 'شماره موبایل وارد نشده' }]}>
      <TcInput placeholder='شماره موبایل' maxLength={11} />
    </TcFormItem>
    <TcInputNationalID />
    <TcFormItem
      label='تلفن ثابت'
      name='telephonNumber'
      // rules={[{ required: true, message: 'نام وارد نشده' }]}
    >
      <TcInput placeholder='مثال : ۰۲۱۴۳۶۵۸۷۹۰' maxLength={11} />
    </TcFormItem>
  </>
);

export const columns = (
  handleDelete?: (_id: string | number) => void,
  disableOperations?: boolean,
  handleMakeDefault?: (_id: number, _isDefault?: boolean) => void
): ColumnsType<client> => {
  const baseColumns: ColumnsType<client> = [
    { title: 'نام و نام خانوادگی', dataIndex: 'fullName', key: 'fullName' },
    { title: 'موبایل', dataIndex: 'mobile', key: 'mobile' },
    { title: 'تلفن ثابت', dataIndex: 'telephoneNumber', key: 'telephoneNumber' },
    {
      title: 'کدملی / کد فراگیر',
      key: 'nationalOrFida',
      width: 110,
      render: (_t, rec) => rec.nationalId || rec.fidaCode || '',
    },

    {
      title: 'فرستنده پیشفرض',
      render: (_text: string, record: client) => {
        if (!handleMakeDefault) return;
        if (record.isDefaultSender)
          return (
            <TcPopconfirm key={1} onConfirm={() => handleMakeDefault(record.id, false)} title='پیشفرض نیست؟'>
              <div className='cursor-pointer w-fit mx-[5px]'>
                <div className='text-t-success-color inherit-color'>
                  <CheckCircleOutlined />
                </div>
              </div>
            </TcPopconfirm>
          );
        return (
          <TcPopconfirm key={2} onConfirm={() => handleMakeDefault(record.id)} title='تبدیل به فرستنده پیشفرض؟'>
            <div className='cursor-pointer w-fit mx-[5px]'>
              <div className='text-t-error-color inherit-color'>
                <CloseCircleOutlined />
              </div>
            </div>
          </TcPopconfirm>
        );
      },
    },
  ];

  const allColumns: ColumnsType<client> = disableOperations
    ? baseColumns
    : [
        ...baseColumns,
        {
          title: 'عملیات',
          key: 'operation',
          render: (_t, rec) => (
            <div>
              <TcEditIcon to={`${routes.clientUpdate.path}/${rec.id}`} />
              {handleDelete && <TcDeletIcon onConfirm={() => handleDelete(rec.id)} />}
            </div>
          ),
        },
      ];
  return allColumns;
};

const clientModel = { columns, title, englishTitle, filterItems, inputs };

export default clientModel;
